export const SEND_ID_EMAIL = {
  FETCH_RECIPIENTS_FAIL: { key: 'FETCH_RECIPIENTS_FAIL', value: 'Error while fetching the recipients, please try again.'},
  UPDATE_RECIPIENTS_FAIL: { key: 'UPDATE_RECIPIENTS_FAIL', value: 'Error while updating the recipients, please try again.'},
  DELETE_ADDRESS_FAIL: { key: 'DELETE_ADDRESS_FAIL', value: 'Error while removing the email address, please try again.'},
  SEND_EMAIL_FAIL: { key: 'SEND_EMAIL_FAIL', value: 'Error while trying to send the mail, please try again.'},
  CONFIRM_MODAL_DESCRIPTION: {
      key: 'CONFIRM_MODAL_DESCRIPTION',
      value: 'Are you sure you want to finalize the changes to the document and send the email with it?'
    },
  SEND_EMAIL_TITLE: { key: 'SEND_EMAIL_TITLE', value: 'SEND EMAIL'},
  SEND_EMAIL_BTN: { key: 'SEND_EMAIL_BTN', value: 'SEND EMAIL'},
  CANCEL_BTN: { key: 'CANCEL_BTN', value: 'CANCEL'},
  SEND_EMAIL_TO_TEXT: { key: 'SEND_EMAIL_TO_TEXT', value: 'To'},
};